import axios from 'axios';

import * as config from '../../config';

export default {
  state: {
    login: {
      username: '',
      password: '',
    },
    register: {
      username: '',
      password: '',
      confirm: '',
    },
  },
  actions: {
    async getCurrentUser({ rootState, commit }) {
      try {
        let response = await axios.get(`${config.API_URL}/users/`);

        commit('update', { state: rootState, property: 'user', value: response.data });

        return response;
      } catch (e) {
        throw e;
      }
    },
    async login({ rootState, state, commit }) {
      try {
        let response = await axios.post(`${config.API_URL}/users/login`, state.login);

        commit('update', { state: rootState, property: 'jwt', value: response.data.token });

        commit('update', { state: rootState, property: 'user', value: response.data.user });

        commit('update', { state, property: 'login', value: { username: '', password: '', } });

        localStorage.setItem('jwt', response.data.token);

        return response;
      } catch (e) {
        throw e;
      }
    },
    async register({ rootState, state, commit }) {
      try {
        let response = await axios.post(`${config.API_URL}/users/register`, state.register);

        commit('update', { state: rootState, property: 'jwt', value: response.data.token });

        commit('update', { state: rootState, property: 'user', value: response.data.user });

        commit('update', { state, property: 'register', value: { username: '', password: '', confirm: '' } });

        localStorage.setItem('jwt', response.data.token);

        return response;
      } catch (e) {
        throw e;
      }
    },
  },
  mutations: {

  },
};